<div>
  <div class="flex flex-row justify-end mt-4 px-20">
    <prism-btn (click)="goToResourcesForm()" btn-class="btn-purple">+ Resources</prism-btn>
  </div>
  <prism-external-resources></prism-external-resources>
</div>

